import { GET_USER_AUTH_DATA } from './auth';
import {
  GET_ENTITY_SCHEMA,
  GET_LISTING_DATA,
  GET_ALL_EDITABLE_ENTITYS_SCHEMA,
  GET_ALL_ENTITY_SCHEMA,
  GET_ENTITY_URL,
  GET_CURRENT_ENTITY,
  GET_PUBLISHED_CONTENT,
  GET_ITEM_LABEL
} from './entity';
import { GET_MENU_ITEMS, GET_USER_EDITABLE_ENTITIES } from './menu';
import { GET_MY_PERMISSIONS } from './permissions';
import { GET_PAGES } from './pages';
import {
  GET_FILES,
  GET_FILES_WHERE,
  GET_FILE_BY_ID,
  GET_COUNT_ALL_FILES,
  GET_FILE_STORES
} from './files';
import { GET_PB_TEMPLATE_STATUS, MERGE_PB_TEMPLATE_CHANGES, GET_PB_TEMPLATE } from './pageBuilder';
import { GET_BANNERS } from './banner';
import { SEARCH_ADMIN_MEDIA, SEARCH_ADMIN, SEARCH_PUBLISHED_CONTENT } from './search';

export default {
  GET_ALL_EDITABLE_ENTITYS_SCHEMA,
  GET_ALL_ENTITY_SCHEMA,
  GET_ENTITY_SCHEMA,
  GET_COUNT_ALL_FILES,
  GET_FILE_BY_ID,
  GET_FILES_WHERE,
  GET_FILES,
  GET_LISTING_DATA,
  GET_MENU_ITEMS,
  GET_MY_PERMISSIONS,
  GET_PAGES,
  GET_PB_TEMPLATE_STATUS,
  MERGE_PB_TEMPLATE_CHANGES,
  GET_PB_TEMPLATE,
  GET_USER_AUTH_DATA,
  GET_USER_EDITABLE_ENTITIES,
  GET_ENTITY_URL,
  GET_CURRENT_ENTITY,
  GET_PUBLISHED_CONTENT,
  GET_BANNERS,
  SEARCH_ADMIN,
  SEARCH_ADMIN_MEDIA,
  GET_FILE_STORES,
  SEARCH_PUBLISHED_CONTENT,
  GET_ITEM_LABEL
};
